import React from 'react';
import { FiMapPin, FiNavigation, FiInfo, FiStar } from 'react-icons/fi';
import PageTransition from '../components/PageTransition';
import SafeIcon from '../common/SafeIcon';

const Location = () => {
  const viewImage = "https://res.cloudinary.com/dtg01111/image/upload/v1739500103/6122d4c0-0387-43c3-b46c-2f9547ea8736.jpg";
  
  /**
   * Verified Google Maps Embed URL for R. Venue Apartelle
   * The '1s0x33bd53006a863583%3A0x69680ee37dfb81e' ID in the PB string 
   * specifically identifies the business entity to ensure the RED PIN is displayed.
   */
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3868.618604313531!2d121.55193917590497!3d14.111497988358485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x33bd53006a863583%3A0x69680ee37dfb81e!2sR.%20Venue%20Apartelle!5e0!3m2!1sen!2sph!4v1739529363066!5m2!1sen!2sph";

  return (
    <PageTransition>
      <div className="bg-brand-cream py-16 text-center px-4">
        <span className="font-script text-3xl text-brand-sage mb-2 block">Explore</span>
        <h1 className="font-serif text-4xl md:text-5xl text-brand-dark uppercase tracking-wider">Our Location</h1>
      </div>

      <div className="container mx-auto px-6 max-w-7xl pb-24">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-brand-sage text-lg font-light leading-relaxed">
            Nestled at the foot of Mount Banahaw, Lucban is renowned for its cool climate and vibrant culture. 
            R. VENUE Apartelle puts you in the absolute center of it all.
          </p>
        </div>

        {/* Map Section */}
        <div className="mb-20">
          <div className="bg-white p-2 rounded-sm shadow-2xl border border-brand-light/30 relative overflow-hidden group">
            {/* Location Badge */}
            <div className="absolute top-6 left-6 z-10 hidden md:block">
              <div className="bg-brand-dark/95 backdrop-blur-md text-brand-cream p-5 rounded-sm shadow-lg max-w-xs border-l-4 border-brand-olive">
                <h4 className="font-serif text-xl mb-1">R. VENUE Apartelle</h4>
                <p className="text-[10px] uppercase tracking-[0.2em] text-brand-light mb-4 leading-relaxed">
                  3rd Floor R. Venue Bldg, Quezon Ave cor Avenida Rizal, Lucban, Quezon
                </p>
                <a 
                  href="https://maps.app.goo.gl/9P6zXoFmC6K1vLzMA" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-brand-olive px-4 py-2 text-white hover:bg-brand-sage transition-colors text-[10px] uppercase tracking-[0.2em] font-bold rounded-sm shadow-sm"
                >
                  <SafeIcon icon={FiNavigation} /> Open in Google Maps
                </a>
              </div>
            </div>

            <iframe 
              src={mapEmbedUrl} 
              className="w-full h-[450px] md:h-[600px]" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              title="R. Venue Location Map"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="relative rounded-sm overflow-hidden shadow-md group">
              <div className="absolute inset-0 bg-brand-dark/10 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
              <img 
                src={viewImage} 
                alt="View from R. Venue" 
                className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            
            <div className="bg-white p-8 rounded-sm border border-brand-light/50 shadow-sm">
              <h3 className="font-serif text-2xl text-brand-dark mb-4 flex items-center gap-2">
                <SafeIcon icon={FiMapPin} className="text-brand-olive" /> Unbeatable Access
              </h3>
              <p className="text-brand-sage font-light mb-6 font-sans leading-relaxed">
                R. VENUE Apartelle is located on the 3rd Floor of the R. Venue Bldg., situated at the corner of Quezon Avenue and Avenida Rizal. This is the pulse of Lucban—where the daily life of the town unfolds.
              </p>
              <div className="flex items-start gap-3 p-4 bg-brand-cream/50 rounded-sm italic text-xs text-brand-sage">
                <SafeIcon icon={FiInfo} className="mt-0.5 text-brand-olive" />
                <span>Our entrance is easily accessible and staff are available to assist with your arrival.</span>
              </div>
            </div>
          </div>

          <div className="bg-brand-olive text-brand-cream p-10 md:p-12 rounded-sm shadow-lg">
            <h3 className="font-serif text-3xl mb-8 border-b border-brand-cream/20 pb-4">Nearby Landmarks</h3>
            <div className="space-y-8">
              {[
                { 
                  name: "Lucban Town Plaza", 
                  desc: "The center of social life in Lucban, just a 2-minute walk away." 
                },
                { 
                  name: "San Luis Obispo Parish", 
                  desc: "Our historic church is within easy walking distance." 
                },
                { 
                  name: "Local Restaurants", 
                  desc: "Authentic local dining options right outside our doors." 
                }
              ].map((loc, idx) => (
                <div key={idx} className="border-b border-brand-cream/10 pb-6 last:border-0 last:pb-0">
                  <h4 className="text-xl font-medium mb-2 flex items-center gap-2">
                    <SafeIcon icon={FiStar} className="text-xs opacity-50" /> {loc.name}
                  </h4>
                  <p className="text-brand-light font-light text-sm leading-relaxed">{loc.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default Location;